import React, { createContext, useContext, useState } from "react";

import ToastAlert from "../components/ToastAlert";

import { IToastAlert } from "../commons/interfaces";
import { ToastType } from "../constants/enums";

import "../styles/comment.css";
import "../styles/toastAlertList.css";

interface AlertContextType {
    showAlert: (message: string, type: ToastType) => void;
    closeAlert: (id: string) => void;
}

const AlertContext = createContext<AlertContextType>(null!);

const useAlert = () => useContext(AlertContext);

const positionData = ["top-right", "top-left", "bottom-right", "bottom-left", "top-center", "bottom-center"];

const position = positionData[5];

let showAlert: (message: string, type: ToastType) => void;

const AlertProvider = ({ children }: { children: React.ReactNode }) => {
    const [data, setData] = useState<IToastAlert[]>([]);

    showAlert = (message: string, type: ToastType) => {
        const alert = {
            id: String(Math.random()),
            message: message,
            type: type,
        };
        setData((prev) => [...prev, alert]);
        setTimeout(() => {
            setData((prev) => [...prev.filter((item) => item.id !== alert.id)]);
        }, 3000);
    };

    const closeAlert = (id: string) => {
        setData((prev) => [...prev.filter((item) => item.id !== id)]);
    };

    const sortedData = position.includes("bottom") ? [...data].reverse() : [...data];

    const value = {
        showAlert,
        useAlert,
        closeAlert,
    };

    return (
        <AlertContext.Provider value={value}>
            <div className={`cr-toast-list cr-toast-${position}`}>
                {sortedData.map((item) => (
                    <ToastAlert item={item} key={item.id} />
                ))}
            </div>
            {children}
        </AlertContext.Provider>
    );
};

export { AlertProvider, showAlert, useAlert };
